var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiverTypeUnidentifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 20C8.8955 20 7.97253 19.0869 8.28385 18.0271C8.35409 17.788 8.43718 17.5523 8.53291 17.3212C8.8847 16.4719 9.40031 15.7003 10.0503 15.0503C10.7003 14.4002 11.472 13.8846 12.3213 13.5328C13.1706 13.1811 14.0808 13 15.0001 13C15.9193 13 16.8296 13.1811 17.6789 13.5328C18.5281 13.8846 19.2998 14.4002 19.9498 15.0503C20.5998 15.7003 21.1154 16.4719 21.4672 17.3212C21.563 17.5523 21.6461 17.788 21.7163 18.0271C22.0276 19.0869 21.1046 20 20.0001 20L10.0001 20Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 7C20.0001 9.76142 17.7615 12 15.0001 12C12.2386 12 10.0001 9.76142 10.0001 7C10.0001 4.23858 12.2386 2 15.0001 2C17.7615 2 20.0001 4.23858 20.0001 7Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 17.0003C12.3332 19.9458 9.94536 22.3337 6.99984 22.3337C4.05432 22.3337 1.6665 19.9458 1.6665 17.0003C1.6665 14.0548 4.05432 11.667 6.99984 11.667C9.94536 11.667 12.3332 14.0548 12.3332 17.0003Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.3333C4.42267 12.3333 2.33333 14.4227 2.33333 17C2.33333 19.5773 4.42267 21.6667 7 21.6667C9.57733 21.6667 11.6667 19.5773 11.6667 17C11.6667 14.4227 9.57733 12.3333 7 12.3333ZM1 17C1 13.6863 3.68629 11 7 11C10.3137 11 13 13.6863 13 17C13 20.3137 10.3137 23 7 23C3.68629 23 1 20.3137 1 17Z",
    fill: "#C6C6C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00014 19.6663L10.5557 16.9997L7.00014 14.333V16.1108H3.44458V17.8886H7.00014L7.00014 19.6663Z",
    fill: "#C6C6C6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10909_51052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 22.8337C10.2217 22.8337 12.8334 20.222 12.8334 17.0003C12.8334 13.7787 10.2217 11.167 7.00008 11.167C3.77842 11.167 1.16675 13.7787 1.16675 17.0003C1.16675 20.222 3.77842 22.8337 7.00008 22.8337Z",
    fill: "#EF4137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 14.667V17.0003M7.00008 19.3337H7.00591M12.8334 17.0003C12.8334 20.222 10.2217 22.8337 7.00008 22.8337C3.77842 22.8337 1.16675 20.222 1.16675 17.0003C1.16675 13.7787 3.77842 11.167 7.00008 11.167C10.2217 11.167 12.8334 13.7787 12.8334 17.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10909_51052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverTypeUnidentifiedIcon);
export default __webpack_public_path__ + "static/media/receiver-type-unidentified-icon.49035d07593421606986b9dd413c8a54.svg";
export { ForwardRef as ReactComponent };